var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"centered":"","color":_vm.accentColor,"background-color":"transparent"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',[_vm._v("Crear")]),_c('v-tab',[_vm._v("Duplicar")])],1),_c('v-tabs-items',{staticStyle:{"background-color":"transparent"},attrs:{"dark":_vm.isDark},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('v-card-text',{staticStyle:{"padding":"0px"}},[_c('MutationForm',{attrs:{"no-reset":"","mutation":"createTable","constants":{ environmentId: _vm.environmentId },"submitButtonText":"Crear","submitButtonIcon":"add","submit-button-color":_vm.accentColor,"environment-variables":{ environmentId: _vm.environmentId },"schema":{
            environmentId: {
              __graphQLType: 'ID'
            },
            name: {
              label: 'Nombre para identificar la tabla',
              type: 'string',
              description: 'Debe ser único y reconocible.',
              fieldOptions: {
                color: _vm.accentColor
              },
              newDesign: true,
              isDark: this.isDark
            },
            title: {
              label: 'Título de la tabla',
              type: 'string',
              optional: true,
              description: 'Opcional. Se mostrará en las vistas.',
              fieldOptions: {
                color: _vm.accentColor
              },
              newDesign: true,
              isDark: this.isDark
            },
            collectionId: {
              label: 'Colección',
              type: 'string',
              fieldType: 'collectionSelect',
              __graphQLType: 'ID',
              description: 'No se puede cambiar una vez creada la tabla.',
              fieldOptions: {
                color: _vm.accentColor
              },
              newDesign: true,
              isDark: this.isDark
            }
          }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{attrs:{"slot":"left-buttons","dark":"","color":"#59a4f4"},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v("Cancelar")])],1)],1)],1),_c('v-tab-item',[_c('v-card-text',{class:{ 'white--text': _vm.isDark }},[_c('div',{staticClass:"overline"},[_vm._v("Se duplicará:")]),_c('div',{staticClass:"caption"},[_vm._v(" - La tabla seleccionada, sus columnas y todas sus opciones ")]),_c('div',{staticClass:"overline"},[_vm._v("NO se duplicará:")]),_c('div',{staticClass:"caption"},[_vm._v("- ID o nombre de la tabla")]),_c('div',{staticClass:"caption"},[_vm._v(" - Cualquier componente (colecciones, filtros, etc) al que esta tabla haga referencia. ")]),_c('MutationForm',{attrs:{"no-reset":"","mutation":"duplicateTable","environmentVariables":{ environmentId: _vm.environmentId },"submitButtonText":"Duplicar","submitButtonIcon":"content_copy","submit-button-color":_vm.accentColor,"schema":{
            tableId: {
              __graphQLType: 'ID',
              label: 'Tabla a copiar',
              fieldType: 'componentSelect',
              fieldOptions: {
                componentTypeName: 'tables'
              },
              newDesign: true
            },
            newName: {
              label: 'Nombre para la nueva tabla',
              type: 'string',
              description: 'Debe ser único y reconocible.',
              fieldOptions: {
                color: _vm.accentColor
              },
              newDesign: true,
              isDark: this.isDark
            }
          }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{attrs:{"slot":"left-buttons","dark":"","color":"#59a4f4"},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v("Cancelar")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }